module.exports = __webpack_public_path__ + "img/blockS2-card4.c9ae6952.svg";